/* Amy Lucy Gift Finder v2 — native Shopify collection facets and AJAX grid updates */
(() => {
  if (window.__amyLucyIntentFinderV2) return;
  window.__amyLucyIntentFinderV2 = true;

  let pendingURL = null;
  let renderRequest = null;

  const getFinder = () => document.querySelector('[data-al-intent-finder]');
  const getMain = () => document.querySelector('[main-content]');
  const getMainSectionId = () => getMain()?.closest('.shopify-section')?.id?.replace(/^shopify-section-/, '') || null;

  const sync = (finder, url) => {
    if (!finder) return;
    const search = url.searchParams;
    finder.querySelectorAll('[data-al-finder-choice]').forEach(input => {
      input.checked = search.getAll(input.name).flatMap(value => value.split(',')).includes(input.value);
    });
    finder.querySelectorAll('[data-al-finder-group]').forEach(group => {
      const num = group.querySelectorAll('[data-al-finder-choice]:checked').length;
      const meta = group.querySelector('[data-al-finder-group-meta]');
      if (meta) meta.textContent = num ? num + ' selected' : 'Choose any';
    });
    const budget = finder.querySelector('[data-al-finder-budget]');
    if (budget) {
      const min = search.get(budget.dataset.min || '') || '';
      const max = search.get(budget.dataset.max || '') || '';
      const selectedValue = min === '' && ['10','15','20'].includes(max) ? 'max:' + max : max === '' && min === '20' ? 'min:20' : '';
      const choices = budget.querySelectorAll('[data-al-budget-choice]');
      choices.forEach(choice => { choice.checked = choice.value === selectedValue; });
      const selectedChoice = budget.querySelector('[data-al-budget-choice]:checked');
      const meta = budget.querySelector('[data-al-budget-meta]');
      if (meta) meta.textContent = selectedChoice?.closest('label')?.querySelector('.al-intent-finder__choice-name')?.textContent?.trim() || 'Any budget';
    }
    const total = Array.from(finder.querySelectorAll('[data-al-finder-choice]:checked')).length +
      (budget && (search.get(budget.dataset.min || '') || search.get(budget.dataset.max || '')) ? 1 : 0);
    const count = finder.querySelector('[data-al-finder-count]');
    const clear = finder.querySelector('[data-al-finder-clear]');
    if (count) count.textContent = total ? total + (total === 1 ? ' choice selected' : ' choices selected') : 'All gifts';
    if (clear) clear.hidden = !Array.from(search.keys()).some(key => key.startsWith('filter.'));
  };

  const apply = (base, modifier) => {
    const finder = getFinder();
    if (!finder) return;
    const next = new URL((base || pendingURL || window.location.href).toString(), window.location.origin);
    modifier(next.searchParams);
    if (finder.closest('.al-search-hero')) next.searchParams.set('type', 'product');
    next.searchParams.delete('page');
    pendingURL = next;
    sync(finder, next);
    const sectionId = getMainSectionId();
    const nativeFacetsReady = sectionId && customElements.get('hdt-facet-filters-form');
    if (!nativeFacetsReady) {
      window.location.assign(next.toString());
      return;
    }
    const sectionUrl = new URL(next.toString());
    sectionUrl.searchParams.set('section_id', sectionId);
    finder.setAttribute('aria-busy','true');
    document.dispatchEvent(new CustomEvent('facet:render', {
      bubbles: true,
      detail: {url: sectionUrl, disableScrollToVIew: true}
    }));
  };

  document.addEventListener('change', (event) => {
    const finder = event.target.closest?.('[data-al-intent-finder]');
    if (!finder) return;
    const target = event.target;
    if (target.matches('[data-al-finder-choice]')) {
      const param = target.name;
      const selected = Array.from(finder.querySelectorAll('[data-al-finder-choice]'))
        .filter(input => input.name === param && input.checked)
        .map(input => input.value);
      apply(null, params => {
        params.delete(param);
        selected.forEach(value => params.append(param, value));
      });
    } else if (target.matches('[data-al-budget-choice]')) {
      const holder = target.closest('[data-al-finder-budget]');
      if (!holder) return;
      holder.dataset.alBudgetDirty = 'yes';
      const budgetGroup = holder.querySelector('[data-al-finder-budget-group]');
      if (budgetGroup) budgetGroup.open = false;
      const min = holder.dataset.min;
      const max = holder.dataset.max;
      apply(null, params => {
        if (min) params.delete(min);
        if (max) params.delete(max);
        const [condition, price] = target.value.split(':');
        if (condition === 'min' && min) params.set(min, price);
        if (condition === 'max' && max) params.set(max, price);
      });
    }
  });

  document.addEventListener('click', (event) => {
    const button = event.target.closest?.('[data-al-finder-clear]');
    if (button && button.closest('[data-al-intent-finder]')) {
      apply(null, params => {
        Array.from(params.keys()).filter(name => name.startsWith('filter.')).forEach(name => params.delete(name));
      });
    }
    const finder = getFinder();
    if (finder && !event.target.closest?.('[data-al-finder-group]')) {
      finder.querySelectorAll('[data-al-finder-group][open]').forEach(group => group.open = false);
    }
  });

  document.addEventListener('submit', (event) => {
    const form = event.target.closest?.('[data-al-finder-form]');
    if (!form) return;
    event.preventDefault();
    const selected = Array.from(form.querySelectorAll('[data-al-finder-choice]:checked'));
    const names = new Set(Array.from(form.querySelectorAll('[data-al-finder-choice]'), input => input.name));
    const budget = form.querySelector('[data-al-finder-budget]');
    apply(null, params => {
      names.forEach(name => params.delete(name));
      selected.forEach(input => params.append(input.name, input.value));
      if (budget && budget.dataset.alBudgetDirty === 'yes') {
        const min = budget.dataset.min;
        const max = budget.dataset.max;
        if (min) params.delete(min);
        if (max) params.delete(max);
        const [op, value] = (budget.querySelector('[data-al-budget-choice]:checked')?.value || '').split(':');
        if (op === 'min' && min) params.set(min, value);
        if (op === 'max' && max) params.set(max, value);
      }
    });
  });

  const refresh = async () => {
    pendingURL = null;
    const finder = getFinder();
    if (!finder) return;
    finder.removeAttribute('aria-busy');
    const wrapper = finder.closest('.shopify-section');
    const id = wrapper?.id?.replace(/^shopify-section-/, '');
    if (!id) { sync(finder, new URL(window.location.href)); return; }
    if (renderRequest) renderRequest.abort();
    renderRequest = new AbortController();
    try {
      const url = new URL(window.location.href);
      url.searchParams.set('section_id', id);
      const res = await fetch(url.href, {signal:renderRequest.signal,credentials:'same-origin'});
      if (!res.ok) throw new Error('Finder section refresh failed');
      const html = new DOMParser().parseFromString(await res.text(),'text/html');
      const updated = html.querySelector('[data-al-intent-finder]');
      if (updated && finder.isConnected) {
        const openKinds = Array.from(finder.querySelectorAll('[data-al-finder-group][open]'), el => el.dataset.alFinderKind);
        finder.innerHTML = updated.innerHTML;
        finder.querySelectorAll('[data-al-finder-group]').forEach(group => {
          if (openKinds.includes(group.dataset.alFinderKind)) group.open = true;
        });
      }
    } catch (error) {
      if (error.name !== 'AbortError') console.warn('Gift Finder: options could not refresh', error);
    }
    sync(getFinder(), new URL(window.location.href));
  };
  document.addEventListener('products:update', refresh);
  window.addEventListener('popstate', () => {
    pendingURL = null;
    sync(getFinder(), new URL(window.location.href));
  });
  document.addEventListener('shopify:section:load', () => sync(getFinder(), new URL(window.location.href)));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => sync(getFinder(),new URL(window.location.href)));
  else sync(getFinder(),new URL(window.location.href));
})();